export default __webpack_public_path__ + "media/images/building_images/placeholder_1section_1-b2c7d766b76c62a50cebc2f481a89561.png";